import script from "./Video.vue?vue&type=script&lang=ts&setup=true"
export * from "./Video.vue?vue&type=script&lang=ts&setup=true"

import "./Video.vue?vue&type=style&index=0&id=35705790&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35705790"]])

export default __exports__